import React, { useState } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function OnePaymentModal({
  selectedPayment,
  cancelModal,
  refundFromOnePayment,
}) {



  const {user} = useAuthContext();
  const [isLoading,setIsLoading] = useState(false)

  const billingPortal = async () => {
    try {
      setIsLoading(true);

      const billingPortalResponse = await axios.get(
        `${ApiConnectionString}/api/ConnectBillingPortal/${selectedPayment.clubId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (billingPortalResponse.status === 200) {
        window.location.href = billingPortalResponse.data;
      }
    } catch (error) {
      console.error("Failed to open billing portal:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const checkIfOver48Hours = (payment) => {
    const createdDate = new Date(payment.created);
    const currentDate = new Date();
    const timeDifference = currentDate - createdDate;
    const hoursDifference = timeDifference / (1000 * 60 * 60);

    return hoursDifference > 48;
  };

  const isOver48Hours = checkIfOver48Hours(selectedPayment);

  const checkIfOver336Hours = (payment) => {
    const createdDate = new Date(payment.created);
    const currentDate = new Date();
    const timeDifference = currentDate - createdDate;
    const hoursDifference = timeDifference / (1000 * 60 * 60);

    return hoursDifference > 336;
  };

  const isOver336Hours = checkIfOver48Hours(selectedPayment);

  if(isLoading){
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
      <LoadingSpinner />
        </div>
      </div>
    );
  }else{
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">Payment</p>
          </div>
  
          <table className="table">
            <thead></thead>
            <tbody>
              <tr>
                <td>Date and time</td>
                <td>{new Date(selectedPayment.created).toLocaleString()}</td>
              </tr>
              <tr>
                <td>Price</td>
                <td>£{selectedPayment.amount / 100}</td>
              </tr>
  
              <tr>
                <td>Product</td>
                <td>{selectedPayment.name}</td>
              </tr>
  
              <tr>
                <td>Club</td>
                <td>{selectedPayment.clubName}</td>
              </tr>
            </tbody>
          </table>
  
          {selectedPayment.type === "PAYG" &&
            (isOver48Hours ? (
              <p className="text-muted">
                This payment is now non-refundable as more than 48 hours have
                passed
              </p>
            ) : (
              <button
                className="saveChanges-button"
                onClick={refundFromOnePayment}
              >
                Request Refund
              </button>
            ))}
  
          {selectedPayment.type === "Subscription" &&
            selectedPayment.firstSubPayment == true &&
            (isOver336Hours ? (
              <p className="text-muted">
                This payment is now non-refundable as more than 14 days have
                passed
              </p>
            ) : (
              <button
                className="saveChanges-button"
                onClick={refundFromOnePayment}
              >
                Request Refund
              </button>
            ))}
          <hr></hr>
          <p>
            You can manage your saved cards, subscriptions, and billing details
            through your Stripe billing portal.
          </p>
          <button className="saveChanges-button" onClick={billingPortal}>
            Manage Billing
          </button>
  
          <button
            type="button"
            className="close-button"
            onClick={cancelModal}
            aria-label="Close"
          >
            &times;
          </button>
  
          <div className="send-modal-footer">
            <button
              onClick={cancelModal}
              className="pointer cancelButton fw-bold mx-2 px-3"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }
  
}
